
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/temi",
      function () {
        return require("private-next-pages/temi/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/temi"])
      });
    }
  